module.exports = __webpack_public_path__ + "static/media/location_icon.b9a5e482.svg";